export const SimpleFormIteratorPrefix = 'RaSimpleFormIterator';

export const SimpleFormIteratorClasses = {
    line: `${SimpleFormIteratorPrefix}-line`,
    index: `${SimpleFormIteratorPrefix}-index`,
    indexContainer: `${SimpleFormIteratorPrefix}-indexContainer`,
    form: `${SimpleFormIteratorPrefix}-form`,
    action: `${SimpleFormIteratorPrefix}-action`,
    leftIcon: `${SimpleFormIteratorPrefix}-leftIcon`,
};
